import { render } from "./ErrorPage.vue?vue&type=template&id=18f6bf43&ts=true"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ErrorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18f6bf43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18f6bf43', __exports__)) {
    api.reload('18f6bf43', __exports__)
  }
  
  module.hot.accept("./ErrorPage.vue?vue&type=template&id=18f6bf43&ts=true", () => {
    api.rerender('18f6bf43', render)
  })

}


export default __exports__